<template>
  <div class="base_member_info_wrap">
    <div class="baseInfoBtnBox">
      <el-button type="primary" @click="isEdit">编辑</el-button>
    </div>
    <el-form label-width="120px" label-position="right">

      <!-- <div class="myDivider">个人信息</div> -->
      <el-collapse v-model="activeNames" class="myDivider">
        <el-collapse-item title="个人信息" name="1">
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="姓名：">{{baseInfo.memberName}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生日：">{{baseInfo.birthday}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄：">{{baseInfo.memberAge||'0'}}岁</el-form-item>
            </el-col>
          </el-row>
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="性别：">{{baseInfo.memberSex == '1' ? '男': baseInfo.memberSex == '2' ? '女' : '未知'}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号码：">{{baseInfo.idNo}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="籍贯：">{{baseInfo.nativePlace}}</el-form-item>
            </el-col>
          </el-row>

          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="民族：">{{baseInfo.nation}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身高(cm)：">{{baseInfo.height}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="体重(kg)：">{{baseInfo.weight}}</el-form-item>
            </el-col>
          </el-row>
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="BMI：">{{baseInfo.bmi}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="血型：">{{baseInfo.bloodType}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="医保卡号：">{{baseInfo.medicalInsuranceCardNumber}}</el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="患者备注：">
            <div class="remark">{{baseInfo.memberRemark}}</div>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="联系方式" name="2">
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="手机：">{{baseInfo.photoNumber}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电话：">{{baseInfo.landline}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="微信：">{{baseInfo.wechatNo}}</el-form-item>
            </el-col>
          </el-row>
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="邮箱：">{{baseInfo.email}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="住址：">{{(baseInfo.memberAddress ||'').replace(/,/g,'')}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="详细地址：">{{baseInfo.homeAddress}}</el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="会员信息" name="3">
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="绑定门店：">{{baseInfo.storeName}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="会员类型：">{{baseInfo.memberType == '2' ? '慢病会员':'普通会员'}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="会员等级：">{{baseInfo.memberLevel == '2' ? '付费会员':'普通会员'}}</el-form-item>
            </el-col>
          </el-row>
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="会员积分：">{{allIntegral}}<el-button type="danger" size="mini" class="detailBtn" @click="showJfPup">查看明细</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="现金余额：">{{memberAccount.usableAmount}}<el-button type="danger" size="mini" class="detailBtn" @click="showAmountPup">查看明细</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item v-if="false" label="来源药企：" prop="enterpriseName">{{baseInfo.enterpriseName}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item v-if="false" label="健康管理师：" prop="photoNumber">{{baseInfo.healthManagePersonName}}</el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="家庭关系" name="4">
          <el-row v-for="(item, index) in baseInfo.memberFamilyList" :key="index">
            <el-col :span="8">姓名：{{item.familyName || '-'}}</el-col>
            <el-col :span="8">手机号码：{{item.phoneNumber||'-'}}</el-col>
            <el-col :span="8">关系：{{filterRelationShip(item.relationship)}}</el-col>
          </el-row>
          <div v-if="baseInfo.memberFamilyList && baseInfo.memberFamilyList.length === 0" class="tips">暂无添加家庭成员</div>
        </el-collapse-item>
        <el-collapse-item title="既往史" name="5">
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="既往病史：">{{baseInfo.anamnesis||'-'}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="药物过敏史：">{{baseInfo.drugAllergyHistory||'-'}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用药史：">{{baseInfo.medicationHistory||'-'}}</el-form-item>
            </el-col>
          </el-row>
          <el-row class="label_width">
            <el-col :span="8">
              <el-form-item label="家族遗传病史：">{{baseInfo.familyHistory||'-'}}</el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="建档信息" name="6">
          <el-form-item label="建档资料："><span class="tip">上传建档资料，最多支持9张图片</span></el-form-item>
          <el-form-item label="">
            <el-image class="imgs" v-for="(item, index) in baseInfo.filingMaterials" :src="item" :preview-src-list="baseInfo.filingMaterials" />
          </el-form-item>
          <el-form-item label="检查报告："><span class="tip">上传体检报表、病例档案等信息，最多支持9张图片</span></el-form-item>
          <el-form-item label="">
            <el-image class="imgs" v-for="(item, index) in baseInfo.inspectionReport" :src="item" :preview-src-list="baseInfo.inspectionReport" />
          </el-form-item>
        </el-collapse-item>
      </el-collapse>

      <!-- <el-form-item label="会员姓名">{{baseInfo.memberName||'-'}}</el-form-item>
        <el-form-item label="手机号码">{{baseInfo.photoNumber}}</el-form-item>
        <el-form-item label="年龄">{{baseInfo.memberAge||'-'}}岁</el-form-item>
        <el-form-item label="性别">{{baseInfo.memberSex || '-'}}</el-form-item>
        <el-form-item label="档案归属">{{baseInfo.phoneRelationship}}</el-form-item>
        <el-form-item label="会员类型">{{baseInfo.memberType == '2' ? '慢病会员':'普通会员'}}</el-form-item>
        <el-form-item label="家庭成员"></el-form-item>
        <el-form-item label="">
            <el-row v-for="(item, index) in baseInfo.memberFamilyList" :key="index">
                <el-col :span="8">姓名：{{item.familyName || '-'}}</el-col>
                <el-col :span="8">手机号码：{{item.phoneNumber||'-'}}</el-col>
                <el-col :span="8">关系：{{filterRelationShip(item.relationship)}}</el-col>
            </el-row>
        </el-form-item> -->
    </el-form>
    <!-- <el-divider content-position="left" class="myDivider">既往史</el-divider> -->

    <my-from-dialog :isModel="false" :title="'积分明细'" :isShow="isShowJfPup" :cancelText="'关闭'" :scrollHeight="'500px'" :okBtn="false" @ok="closeJfPup('ok')" @cancel="closeJfPup" @closeCallBack="closeJfPup">
      <template slot="froms">
        <el-form :inline="true" ref="jfQueryParams" class="demo-form-inline">
          <el-form-item label="时间" prop="date">
            <el-date-picker v-model="jfDate" type="daterange" @change="handleChangeTime" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch1">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <p>累计积分：{{allIntegral}}</p>
        <el-table :data="integralList" show-header border style="width: 100%" height="300px">
          <el-table-column type="index" align="center" label="序号" />
          <el-table-column prop="createTime" align="center" label="时间" />
          <el-table-column align="center" label="任务">
            <template slot-scope="scope">{{formatType(scope.row.operationType)}}</template>
          </el-table-column>
          <el-table-column prop="operationIntegral" align="center" label="积分">
            <template slot-scope="scope">
              <p v-if="scope.row.operationWay == 2">-{{scope.row.operationIntegral}}</p>
              <p v-if="scope.row.operationWay == 1">+{{scope.row.operationIntegral}}</p>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div slot="footer" class="dialog-footer">
          <el-button @click="isShowJfPup = false">取 消</el-button>
          <el-button type="primary" @click="isShowJfPup = false">确 定</el-button>
        </div> -->
        <div class="pager">
          <el-pagination :current-page.sync="jfQueryParams.pageNum" :page-size="jfQueryParams.pageSize" @size-change="jfBarSizeChange" @current-change="jfBarCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background layout="total, sizes, prev, pager, next" :total="integralTotal"></el-pagination>
        </div>
      </template>
    </my-from-dialog>

    <my-from-dialog :isModel="false" :title="'现金账户明细'" :cancelText="'关闭'" :scrollHeight="'500px'" :okBtn="false" :isShow="isShowAmountShowJfPup" @ok="closeAmountPup('ok')" @cancel="closeAmountPup" @closeCallBack="closeAmountPup">
      <template slot="froms">
        <el-form :inline="true" ref="jfQueryParams" class="demo-form-inline">
          <el-form-item label="时间" prop="date">
            <el-date-picker v-model="jfDate" type="daterange" @change="handleChangeTime" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch1">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="money_middle">
          <p>可提现约：{{memberAccount.usableAmount}}</p>
          <p>累计提现：{{memberAccount.allWithdrawDeposit}}</p>
        </div>
        <el-table :data="integralList" show-header border style="width: 100%" height="300px">
          <el-table-column type="index" align="center" label="序号" />
          <el-table-column prop="createTime" align="center" label="时间" />
          <el-table-column align="center" label="类型">
            <template slot-scope="scope">{{formatMoneyType(scope.row.operationType)}}</template>
          </el-table-column>
          <el-table-column prop="operationIntegral" align="center" label="金额">
            <template slot-scope="scope">
              <p v-if="scope.row.operationWay == 2">-{{scope.row.operationMoney}}</p>
              <p v-if="scope.row.operationWay == 1">+{{scope.row.operationMoney}}</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager">

          <el-pagination :current-page.sync="jfQueryParams.pageNum" :page-size="jfQueryParams.pageSize" @size-change="jfBarSizeChange" @current-change="jfBarCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background layout="total, sizes, prev, pager, next" :total="integralTotal"></el-pagination>
        </div>
      </template>
    </my-from-dialog>
  </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog'; // 弹窗
export default {
  components: { myFromDialog },
  props: {
    memberId: Number, // 会员ID
    pageType: { // 页面类型 1:会员列表 2:慢病会员
      type: String,
      default: '1'
    },
    // baseInfo: { // 会员表单
    //   type: Object,
    //   default: function () {
    //     return {};
    //   }
    // },
  },
  watch: {
    isShowJfPup(n, o) {
      if (n == true) {
        this.jfDate = [];
        this.jfQueryParams = {
          pageNum: 1,
          pageSize: 10,
          memberId: null,
          beginTime: null,
          endTime: null
        }
        this.MemberIntegral();

      }
    },
    isShowAmountShowJfPup(n, o) {
      if (n == true) {
        this.jfDate = [];
        this.jfQueryParams = {
          pageNum: 1,
          pageSize: 10,
          memberId: null,
          beginTime: null,
          endTime: null
        }
        this.MemberIntegral();

      }
    }
    // memberForm: {
    //   handler: function(n, o) {
    //     let memberAddress = n.memberAddress && n.memberAddress.split(",") || '';
    //     if (n.memberSex) {
    //       n.memberSex = n.memberSex == '男' ? '1': '2';
    //     }
    //     if (memberAddress) {
    //       this.preSelectItem = { province: memberAddress[0], city: memberAddress[1], area: memberAddress[2], areaCode: '' };
    //     }
    //     this.memberLabelIds = n.memberLabelIds || [];
    //     this.memberFamilyList = n.memberFamilyList || [];
    //     // console.log(n, o);
    //   },
    //   // deep:true
    //   immediate: true
    // }
    // memberForm(n, o) {
    // }
  },
  created() {
    this.getMemberInfo();
    this.totalIntegral();
    this.MemberTotalMoney();
  },
  data() {
    return {
      // ----------------------------------------------- 积分s
      isShowJfPup: false,
      isShowAmountShowJfPup: false,
      jfQueryParams: {
        pageNum: 1,
        pageSize: 10,
        memberId: null,
        beginTime: null,
        endTime: null
      },
      jfDate: [],
      allIntegral: 0,
      integralList: [],
      integralTotal: null,
      jfTotalCount: 0,
      memberAccount: {},
      activeNames: ['1'],
      yqData: JSON.parse(localStorage.getItem('loginData')) || {}, // 登录药企基本信息
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      baseInfo: {}
      // memberRules: this.getMemberRules(), // 规则
      // loginData: JSON.parse(localStorage.getItem('loginData')) || {}, // 登录药企基本信息
      // storeList: [], // 门店列表
      // preSelectItem: { province: '', city: '', area: '', areaCode: '' }, // 地区
      // memberLabelList: [], // 会员标签
    }
  },
  methods: {
    /**
     * 积分明细接口
     */
    // 积分明细
    closeAmountPup(state) { // 关闭弹窗
      this.isShowAmountShowJfPup = false;
    },
    closeJfPup(state) { // 关闭弹窗
      this.isShowJfPup = false;
    },
    MemberIntegral() {
      console.log('id====', this.isShowJfPup)
      this.jfQueryParams.memberId = this.memberId;
      let url = '';
      if (this.isShowJfPup == true) {
        url = '/system/memberIntegralOperationDetail/list';
      } else {
        url = '/system/memberAccountOperationDetail/list';
      }
      this.$https.post(url, this.jfQueryParams).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.integralList = res.data.records;
          this.integralTotal = res.data.total;
        }
      })
    },
    // 查询会员积分
    totalIntegral() {
      let params = {
        memberId: this.memberId
      }
      this.$https.get('/system/memberIntegral/getIntegralInfo', params).then(res => {
        if (res.code == 200) {
          this.allIntegral = res.data && res.data.allIntegral || 0;
        }
      })
    },
    // 查询会员余额
    MemberTotalMoney() {
      let params = {
        memberId: this.memberId
      }
      this.$https.get('/system/memberAccountInfo/getMemberUsableAmountAndAllWithdrawDeposit', params).then(res => {
        if (res.code == 200) {
          this.memberAccount = res.data;
        }
      })
    },
    // 积分任务格式化
    formatType(type) {
      return {
        1: '签到',
        2: '补卡',
        3: '兑换礼品',
        4: '积分过期',
        5: '注册',
        6: '连续签到赠送'
      }[type]
    },
    // 查询
    onSearch1() {
      this.jfQueryParams.pageNum = 1;
      this.jfQueryParams.pageSize = 10;
      this.MemberIntegral();
    },
    // 重置
    onReset() {
      this.jfQueryParams = {
        pageNum: 1,
        pageSize: 10,
        memberId: null,
        beginTime: null,
        endTime: null
      };
      this.jfDate = []
      this.MemberIntegral();
    },
    showJfPup() { // 显示积分弹窗
      this.isShowJfPup = true;
    },
    // 时间
    handleChangeTime(val) {
      console.log(val);
      this.jfQueryParams.beginTime = this.formatDate(val[0].getTime()) + ' 00:00:00'
      this.jfQueryParams.endTime = this.formatDate(val[1].getTime()) + ' 23:59:59'
    },
    /**
    * 格式化时间
    */
    formatDate(dateTime) {
      // debugger
      let date = new Date(dateTime);
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();

      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      console.log(myyear + "-" + mymonth + "-" + myweekday)
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    jfBarSizeChange(val) {
      this.jfQueryParams.pageSize = val;
      // this.getMemberList();
      this.MemberIntegral();
    },
    jfBarCurrentChange(val) {
      this.jfQueryParams.pageNum = val;
      this.MemberIntegral();
    },
    showAmountPup() { // 显示积分弹窗
      this.isShowAmountShowJfPup = true;

    },
    formatMoneyType(type) {
      return {
        1: '现金返现',
        2: '余额提现',
        3: '活动订单',
        4: '退款'
      }[type]
    },
    getBmiBlur() { // 计算BMI 60kg/((160cm/100)^2)
      if (this.baseInfo.height && this.baseInfo.weight) {
        const bmi = (this.baseInfo.weight / ((this.baseInfo.height / 100) * (this.baseInfo.height / 100))).toFixed(2);
        this.$set(this.baseInfo, 'bmi', bmi);
      } else {
        this.$set(this.baseInfo, 'bmi', '');
      }
    },
    getMemberInfo() { // 获取会员信息
      this.$https.get('system/memberArchives/getArchivesInfoByMemberId', { memberId: this.memberId, enterpriseId: this.yqData.enterpriseId }).then(res => {
        this.baseInfo = res.data || [];
        this.baseInfo.filingMaterials = this.baseInfo.filingMaterials && JSON.parse(this.baseInfo.filingMaterials);
        this.baseInfo.inspectionReport = this.baseInfo.inspectionReport && JSON.parse(this.baseInfo.inspectionReport);
        this.getBmiBlur();
        console.log(this.baseInfo);
        // this.memberForm
        // Object.assign(this.memberForm, this.memberForm.memberInfo);
        console.log('获取会员详情========>', res);
      }).catch(res => {

      })
    },
    isEdit() {
      this.$emit('isEdit', true);
    },
    filterRelationShip(str) { // 过滤关系
      return {
        '0': '父亲',
        '1': '母亲',
        '2': '儿子',
        '3': '女儿',
        '4': '配偶'
      }[str + ""] || "-";
    },
  }
}
</script>

<style lang="less" scoped>
.base_member_info_wrap {
    // margin-top: 20px;
}
.myDivider {
    // padding: 10px;
    // margin: 20px 0;
    // background: rgb(192, 196, 204);
    // border-left: 4px solid #409EFF;
    // font-size: 15px;
    // font-weight: bold;
    /deep/ .el-collapse-item__header {
        margin-bottom: 15px;
        padding: 0 10px;
        background: #f1f1f1;
        border-left: 4px solid #f56c6c;
        font-size: 15px;
        font-weight: bold;
    }
}
.label_width {
    width: 100%;
}
.baseInp {
    width: 300px;
}
.smallInp {
    width: 150px;
}
.familsItem {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    margin-bottom: 15px;
    .familsInp {
        margin-right: 15px;
        .label {
            margin-right: 15px;
        }
    }
}
.remark {
    padding: 10px;
    background: #eee;
    width: 400px;
}
.tips {
    text-align: center;
    color: red;
    font-size: 14px;
    font-weight: bold;
}
.baseInfoBtnBox {
    margin-bottom: 10px;
    text-align: right;
    padding-right: 20px;
}
.imgs {
    width: 100px;
    height: 100px;
    margin-right: 10px;
}
.detailBtn {
    margin-left: 20px;
}
.pager {
    margin: 20px;
    text-align: center;
}
.money_middle {
    display: flex;
    p {
        margin-right: 20px;
    }
}
</style>
